import styled, { css } from "styled-components";

interface StyledDialogFooterProps {
  $divider: boolean;
}

export const StyledDialogFooter = styled.footer<StyledDialogFooterProps>`
  box-sizing: border-box;
  padding: 0 1.6rem 1.6rem 1.6rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;

  ${({ $divider }) =>
    $divider &&
    css`
      border-top: 1px solid var(--bg-gray-2);
      padding-top: 0.8rem;
    `}
`;
